export const DEFAULT_TABLE_HEIGHT = 629;
export const TABLE_HEADER_HEIGHT = 60;
export const TABLE_SPACING_BOTTOM_HEIGHT = 60;
